import { render, staticRenderFns } from "./EcologicalCooperationSharePlatform.vue?vue&type=template&id=3e379b6e&scoped=true"
import script from "./EcologicalCooperationSharePlatform.vue?vue&type=script&lang=js"
export * from "./EcologicalCooperationSharePlatform.vue?vue&type=script&lang=js"
import style0 from "./EcologicalCooperationSharePlatform.vue?vue&type=style&index=0&id=3e379b6e&prod&lang=css"
import style1 from "./EcologicalCooperationSharePlatform.vue?vue&type=style&index=1&id=3e379b6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e379b6e",
  null
  
)

export default component.exports